import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http'; // Import HttpClientModule
import { IdentityService } from './identity/services/identity.service';
import { RoutingModule } from './app-routing.module';
import { ToastrModule, ToastrService } from 'ngx-toastr';
import { AppComponent } from './app.component';
import { ServicerModule } from './servicer/servicer.module';
import { AdvisorModule } from './advisor/advisor.module';
import { RequestVerificationInterceptor } from './core/request-verification.interceptor';
import { UnauthorizedInterceptor } from './unauthorized.interceptor';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    RoutingModule,
    HttpClientModule,
    ToastrModule.forRoot({
      closeButton: true,
      newestOnTop: true,
      progressBar: true,
      positionClass: 'toast-top-center',
      preventDuplicates: false,
      onActivateTick: true,
      extendedTimeOut: 3000,
      timeOut: 7000,
    }),
    ServicerModule,
    AdvisorModule,
    BrowserAnimationsModule,
  ],
  providers: [
    IdentityService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RequestVerificationInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: UnauthorizedInterceptor,
      multi: true,
    },
  //  ToastrService,
  //  {
  //    provide: 'ToastConfig',
  //    useValue: {
  //      timeOut: 3000,
  //      positionClass: 'toast-top-right',
  //      preventDuplicates: true,
  //    },
  //  },
  ],
  exports: [
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }

